import { createAction } from '@ngrx/store';

const logOut = createAction('[Account] log out');

export const AccountActions = {
  logOut,
};
